var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33366 5.40748H16.667C16.8971 5.40748 17.0837 5.59266 17.0837 5.82109V14.1789C17.0837 14.4074 16.8971 14.5925 16.667 14.5925H3.33366C3.10354 14.5925 2.91699 14.4074 2.91699 14.1789V5.82109C2.91699 5.59266 3.10354 5.40748 3.33366 5.40748ZM1.66699 5.82109C1.66699 4.90738 2.41318 4.16667 3.33366 4.16667H16.667C17.5875 4.16667 18.3337 4.90738 18.3337 5.82109V14.1789C18.3337 15.0926 17.5875 15.8333 16.667 15.8333H3.33366C2.41318 15.8333 1.66699 15.0926 1.66699 14.1789V5.82109ZM4.9235 6.33738C4.64971 6.12873 4.25735 6.1799 4.04715 6.45168C3.83695 6.72346 3.8885 7.11293 4.16229 7.32159L7.54485 9.89944L4.16043 12.6935C3.89504 12.9126 3.85883 13.3037 4.07955 13.5672C4.30026 13.8306 4.69433 13.8666 4.95972 13.6475L8.56136 10.6741L9.61972 11.4807C9.84419 11.6518 10.1565 11.6518 10.3809 11.4807L11.4394 10.6741L15.0409 13.6474C15.3063 13.8665 15.7004 13.8305 15.9211 13.5671C16.1418 13.3036 16.1056 12.9125 15.8402 12.6934L12.4559 9.89939L15.8384 7.32159C16.1122 7.11293 16.1637 6.72346 15.9535 6.45168C15.7433 6.1799 15.3509 6.12873 15.0771 6.33738L10.0003 10.2064L4.9235 6.33738Z",
    fill: "#FF6319"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.a09db65d711ec43998c8a3f5ef68acd7.svg";
export { ForwardRef as ReactComponent };